import { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import { AskByEmailWidget } from "@/components/widget/AskByEmailWidget";
import { DEFAULT_BRANDING } from "@/types/ui/branding";
import type { GenieBranding } from "@/types/ui/branding";
import { getBrandThemeFromColors } from "@/utils/branding/genieBrandTheme";
import { getContrastingTextColor } from "@/lib/utils";

// The host supplies this same branding object from its Genie in a real embed.
const EXAMPLE_BRANDING: GenieBranding = {
  ...DEFAULT_BRANDING,
  logoUrl: "/helpgenie_logo.png",
  embedStyle: {
    ...DEFAULT_BRANDING.embedStyle,
    borderRadius: 24,
    fontFamily: "inherit",
  },
};

const AskByEmailExample = () => {
  const [open, setOpen] = useState(true);
  const launcherRef = useRef<HTMLButtonElement>(null);
  const theme = getBrandThemeFromColors(EXAMPLE_BRANDING);

  useEffect(() => {
    if (!open) launcherRef.current?.focus();
  }, [open]);

  return (
    <main className="flex min-h-[100dvh] items-center justify-center bg-genie-background px-4 py-8">
      <Helmet>
        <title>Ask by email — Widget example | Help Genie</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="w-full max-w-md space-y-4">
        <p className="text-center text-xs text-gray-500">Widget preview · No emails sent</p>
        <div hidden={!open}>
          <AskByEmailWidget preview genieName="Willow" branding={EXAMPLE_BRANDING} onClose={() => setOpen(false)} />
        </div>
        {!open && (
          <div className="flex justify-center">
            <button
              ref={launcherRef}
              type="button"
              className="min-h-12 rounded-full px-6 py-3 text-sm font-semibold shadow-lg hover:opacity-90"
              style={{ background: theme.gradient, color: getContrastingTextColor(theme.primary) }}
              onClick={() => setOpen(true)}
            >
              Ask Willow by email
            </button>
          </div>
        )}
      </div>
    </main>
  );
};

export default AskByEmailExample;
